import React, { useState, useEffect, useMemo } from "react";
import FilterForm from "app/Components/FilterForm/FilterForm";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";
import { capaFilterFields } from "../IncidentManagement/CONSTANTS";
import moment from "moment";

export default function CapaFilter({ form, onChange, onReset, setForm }) {
  const [state, setState] = useState({
    sites: [],
  });

  useEffect(() => {
    getAllSites("filter[status]=1").then((response) => {
      if (!response?.data) return;

      setState((prev) => ({
        ...prev,
        sites: response.data.map((row) => ({ label: row.name, value: row.id })),
        roSites: response.data
          .filter((d) => d.siteType !== 2)
          .map((row) => ({ label: row.name, value: row.id })),
      }));
    });
  }, []);

  const fields = useMemo(
    () =>
      capaFilterFields.map((f) => {
        const field = { ...f };

        switch (field.name) {
          case "siteId":
            field.options = state.sites;
            break;

          default:
            break;
        }

        return field;
      }),
    [state.sites]
  );

  const handleDateRange = (dates) => {
    onChange({
      target: {
        name: "startDate",
        value: dates.startDate
          ? moment(new Date(dates.startDate)).format("YYYY-MM-DD")
          : null,
      },
    });
    onChange({
      target: {
        name: "endDate",
        value: dates.endDate
          ? moment(new Date(dates.endDate)).format("YYYY-MM-DD")
          : null,
      },
    });
  };
  return (
    <div className="pb-4">
      <FilterForm
        fields={fields}
        form={form}
        onChange={onChange}
        onReset={onReset}
        handleDateRange={handleDateRange}
        startDate={form?.startDate || null}
        endDate={form?.endDate || null}
      />
    </div>
  );
}
